import {createSvgIcon} from '../create-svg-icon';

export const FormatSizeIcon = createSvgIcon(
  <path d="M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z" />
, 'FormatSizeOutlined');
